import { render, staticRenderFns } from "./threshold_directionColumn.vue?vue&type=template&id=27932066&scoped=true&"
import script from "./threshold_directionColumn.vue?vue&type=script&lang=js&"
export * from "./threshold_directionColumn.vue?vue&type=script&lang=js&"
import style0 from "./threshold_directionColumn.vue?vue&type=style&index=0&id=27932066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27932066",
  null
  
)

export default component.exports